var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('animate-number',{ref:"number",attrs:{"formatter":_vm.formatNumber,"to":_vm.data,"duration":_vm.duration,"from":"0","easing":"easeOutQuad","mode":"manual"}})}
var staticRenderFns = []

export { render, staticRenderFns }